import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";

export default function KH1000220009() {
  const { i18n } = useTranslation();

  if (i18n.language === "en") {
    return (
      <>
        <p>
          1. Neak Oknha Kith Meng
          <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
            (b)
          </span>
          <Tooltip target=".b" position="right" event="both">
            Chairman
          </Tooltip>
        </p>
        <p>
          2. Mr. William Mark Hanna
          <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
            (c)
          </span>
          <Tooltip target=".c" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          3. Mr. Paul Carey Clements
          <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
            (d)
          </span>
          <Tooltip target=".d" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          4. Mr. Christopher Donald Tiffin
          <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
            (e)
          </span>
          <Tooltip target=".e" position="right" event="both">
            Non-Executive Director
          </Tooltip>
        </p>
        <p>
          5. Ms. Hep Seka
          <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
            (f)
          </span>
          <Tooltip target=".f" position="right" event="both">
            Independent Director
          </Tooltip>
        </p>
      </>
    );
  }
  return (
    <>
      <p>
        ១. អ្នកឧញ៉ា គិត ម៉េង
        <span className="vertical-align-super b text-xs text-yellow-500 pl-1">
          (b)
        </span>
        <Tooltip target=".b" position="right" event="both">
          ប្រធានក្រុមប្រឹក្សាភិបាល
        </Tooltip>
      </p>
      <p>
        ២. លោក William Mark Hanna
        <span className="vertical-align-super c text-xs text-yellow-500 pl-1">
          (c)
        </span>
        <Tooltip target=".c" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៣. លោក. Paul Carey Clements
        <span className="vertical-align-super d text-xs text-yellow-500 pl-1">
          (d)
        </span>
        <Tooltip target=".d" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៤. លោក. Christopher Donald Tiffin
        <span className="vertical-align-super e text-xs text-yellow-500 pl-1">
          (e)
        </span>
        <Tooltip target=".e" position="right" event="both">
          អភិបាលមិនប្រតិបត្តិ
        </Tooltip>
      </p>
      <p>
        ៥. លោកស្រី ហិប សិកា
        <span className="vertical-align-super f text-xs text-yellow-500 pl-1">
          (f)
        </span>
        <Tooltip target=".f" position="right" event="both">
          អភិបាលឯករាជ្យ
        </Tooltip>
      </p>
    </>
  );
}
